import { Link } from '@amzn/stencil-react-components/link';
import React from 'react';
import { Text } from '@amzn/stencil-react-components/text';

export interface ValidationErrorConfig {
  id: string;
  labelText: string;
  formFieldErrorKey: string;
  isError: boolean;
}
export interface ValidationErrorProps {
  errorConfigs: ValidationErrorConfig[];
}

const ValidationErrors = ({ errorConfigs }: ValidationErrorProps) => {
  const validationErrorsCount = Object.values(errorConfigs).filter(({ isError }) => isError).length;

  if (validationErrorsCount === 0) {
    return <></>;
  }

  return (
    <>
      <Text>{`Please fill the following ${validationErrorsCount} required fields:`}</Text>
      <ul>
        {errorConfigs.map(
          (config) =>
            config.isError && (
              <li key={config.id}>
                <Link href={`#${config.id}`}>{config.labelText}</Link>
              </li>
            ),
        )}
      </ul>
    </>
  );
};

export default ValidationErrors;
